import { handleAction } from 'redux-actions';

import * as Actions from 'flex/Actions';

const defaultState = {
    meta: {
        fetch: false,
        status: '',
        viewName: '',
    },
    payload: {},
};

const defaultReducer = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    next: (state: any, action: any) => {
        return { ...action };
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    throw: (state: any, action: any) => {
        return (Object.assign(action, {
            meta: {
                fetch: false,
                status: Actions.statusEnum.FAILURE,
            },
        }));
    },
};

/** セキュリティ設定全体 取得 */
export const securityGetSettingsConnection = handleAction(
    Actions.http.connection.security.getSettings,
    defaultReducer,
    defaultState
);

/** セキュリティ設定全体 更新 */
export const securityUpdateSettingsConnection = handleAction(
    Actions.http.connection.security.updateSettings,
    defaultReducer,
    defaultState
);